module.exports = __webpack_public_path__ + "img/ic-upoint.1770a426.svg";